
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Radio as RadioIcon, BarChart2, Bell, Globe } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import RadioSpinsOverview from '@/components/radio/RadioSpinsOverview';
import RadioInsights from '@/components/radio/RadioInsights';
import RadioNotificationSettings from '@/components/radio/RadioNotificationSettings';
import RadioWorldMap from '@/components/radio/RadioWorldMap';

const Radio: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 animate-fade-in">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              <RadioIcon className="h-10 w-10 text-blue-500" />
              Radio Tracking
            </h1>
            <p className="text-muted-foreground text-lg">Monitor your radio spins, analytics, and notifications worldwide</p>
          </div>
        </div>

        <Tabs defaultValue="overview" className="w-full">
          <TabsList className="grid grid-cols-2 md:grid-cols-4 mb-8">
            <TabsTrigger value="overview" className="flex items-center gap-2">
              <RadioIcon className="h-4 w-4" />
              <span>Overview</span>
            </TabsTrigger>
            <TabsTrigger value="insights" className="flex items-center gap-2">
              <BarChart2 className="h-4 w-4" />
              <span>Insights</span>
            </TabsTrigger>
            <TabsTrigger value="world-map" className="flex items-center gap-2">
              <Globe className="h-4 w-4" />
              <span>World Map</span>
            </TabsTrigger>
            <TabsTrigger value="notifications" className="flex items-center gap-2">
              <Bell className="h-4 w-4" />
              <span>Notifications</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-6">
            <RadioSpinsOverview />
          </TabsContent>

          <TabsContent value="insights" className="space-y-6">
            <RadioInsights />
          </TabsContent>

          <TabsContent value="world-map" className="space-y-6">
            <RadioWorldMap />
          </TabsContent>

          <TabsContent value="notifications" className="space-y-6">
            <RadioNotificationSettings />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Radio;
